module.exports = __webpack_public_path__ + "static/media/insitu_haz_lev.326c1b2c.png";